document.addEventListener('DOMContentLoaded', () => {
  const listType = properties_ajax.list_type || 'property';
  const propertyListContentWrapper = document.getElementById(`${listType}-list-content-wrapper`);
  const propertyList = document.querySelector(`.${listType}-list__list`);
  const propertyListWrapper = document.querySelector(`.${listType}-list__list-wrapper`);
  const propertyListInvestment = document.querySelector(`.${listType}-list__investment`);
  const propertyListModalInvestment = document.querySelector(`#investment-map-modal .${listType}-list__investment`);
  const propertyListStatus = document.querySelector(`.${listType}-list__list-status-bar`);
  const propertyLoadMoreBtn = document.querySelector(`.${listType}-ajax-load-more-btn`);

  // Load more button action
  document.querySelector(`.${listType}-ajax-load-more-btn`)?.addEventListener('click', async () => {
    const fetchParams = new URLSearchParams(window.location.search);

    const btnSpinner = propertyLoadMoreBtn.querySelector('.spinner-border');
    btnSpinner?.classList.remove('d-none');
    propertyLoadMoreBtn.disabled = true;

    try {
      await asyncFetchPropertiesData(fetchParams);
    } catch (error) {
      console.error('[Load More] Error fetching data:', error);
    } finally {
      btnSpinner?.classList.add('d-none');
      propertyLoadMoreBtn.disabled = false;
    }
  });

  // Sort toggle buttons action
  const sortToggleBtnList = document.querySelectorAll(`.btn-sort-toggle`);
  sortToggleBtnList.forEach((toggleBtn) =>
    toggleBtn.addEventListener('click', async () => {
      const sortField = toggleBtn.dataset.sortField;
      const sortOrder = toggleBtn.dataset.sortOrder;
      const fetchParams = new URLSearchParams(window.location.search);

      const isActive = toggleBtn.classList.contains('active');

      sortToggleBtnList.forEach((btn) => btn.classList.remove('active'));
      let newOrder = sortOrder;
      if (isActive) newOrder = sortOrder === 'asc' ? 'desc' : 'asc';

      fetchParams.set('order_by', sortField);
      fetchParams.set('order', newOrder);

      toggleBtn.dataset.sortOrder = newOrder;
      toggleBtn.classList.add('active');

      try {
        await asyncFetchPropertiesData(fetchParams, true);
      } catch (error) {
        console.error('[Sort Btn] Error fetching data:', error);
      }
    })
  );

  const sortMobileFormBtn = document.querySelector(`.${listType}-list__sort-form-submit-btn`);
  sortMobileFormBtn?.addEventListener('click', async () => {
    const fetchParams = new URLSearchParams(window.location.search);

    const checkedSortOption = document.querySelector(`.radio-btns-group input[name="order"]:checked`);

    const checkedSortField = checkedSortOption.dataset.sortField;
    const checkedSortOrder = checkedSortOption.dataset.sortOrder;

    if (checkedSortField && checkedSortOrder) {
      fetchParams.set('order_by', checkedSortField);
      fetchParams.set('order', checkedSortOrder);
    }

    try {
      await asyncFetchPropertiesData(fetchParams, true);
    } catch (error) {
      console.error('[Sort Mobile Btn] Error fetching data:', error);
    }
  });

  // General submit button action
  document.addEventListener('submit', async (e) => {
    e.preventDefault();

    const form = e.target.closest(`.${listType}-list__filters-form`);
    if (!form) return;

    // Get FormData and filter out empty values
    const formData = new FormData(form);
    const fetchParams = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value !== '' && value !== null) {
        fetchParams.append(key, value !== 'on' ? value : 1);
      }
    }

    try {
      await asyncFetchPropertiesData(fetchParams, true);
    } catch (error) {
      console.error('[Filters Form Submit] Error fetching data:', error);
    }
  });

  // Reset function triggered by onClick on reset buttons
  /*@__PURE__*/ function resetPropertyListFiltersButton() {
    const forms = document.querySelectorAll(`.${listType}-list__filters-form`);

    forms.forEach(async (form) => {
      await resetPropertyFiltersForm(form);
    });

    const sortToggleBtnList = document.querySelectorAll(`.btn-sort-toggle`);
    sortToggleBtnList.forEach((btn) => btn.classList.remove('active'));

    const sortMobileBtnList = document.querySelectorAll(`.radio-btns-group input[name="order"]`);
    sortMobileBtnList.forEach((btn) => (btn.checked = false));

    try {
      asyncFetchPropertiesData(new URLSearchParams(), true, true);

      const currentURL = new URL(window.location.href);
      currentURL.search = '';
      window.history.pushState({}, '', currentURL);
    } catch (error) {
      console.error('[Reset form] Error fetching data:', error);
    }
  }
  window.resetPropertyListFiltersButton = resetPropertyListFiltersButton;

  // General reset of all form fields used by resetPropertyListFiltersButton
  async function resetPropertyFiltersForm(form) {
    form.reset();

    const checkboxes = form.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });

    const selects = form.querySelectorAll('select');
    selects.forEach((select) => {
      select.selectedIndex = 0;
    });
  }

  // General fetch functions for properties
  async function asyncFetchPropertiesData(
    fetchParams = new URLSearchParams(),
    triggeredBySortFilter = false,
    triggeredByReset = false,
  ) {
    const searchQueryParams = new URLSearchParams(window.location.search);
    const cityQuery = searchQueryParams.get('city');
    const orderByQuery = searchQueryParams.get('order_by');
    const orderQuery = searchQueryParams.get('order');
    if (!triggeredByReset) {
      if (orderByQuery && !fetchParams.has('order_by')) fetchParams.append('order_by', orderByQuery);
      if (orderQuery && !fetchParams.has('order')) fetchParams.append('order', orderQuery);
    }

    if (cityQuery && !fetchParams.has('city') && listType == 'property') fetchParams.append('city', cityQuery);

    const totalPropertiesStatus = propertyListStatus.querySelector(
      '[data-status-total-properties]'
    ).dataset.statusTotalProperties;
    const currentPropertiesStatus = propertyListStatus.querySelector(
      '[data-status-current-properties]'
    ).dataset.statusCurrentProperties;

    const offset = Number(propertyList.dataset.offset);
    const limit = Number(propertyList.dataset.limit);

    fetchParams.append('action', properties_ajax.action);
    fetchParams.append('security', properties_ajax.nonce);
    fetchParams.append('list_type', listType);

    if (!triggeredBySortFilter) {
      fetchParams.append('offset', offset);
      fetchParams.append('limit', limit);
      fetchParams.append('totalPropertiesStatus', totalPropertiesStatus);
      fetchParams.append('currentPropertiesStatus', currentPropertiesStatus);
    }

    // Show loading state
    if (
      triggeredBySortFilter &&
      !propertyListContentWrapper.querySelector('.loading-state-wrapper')
    ) {
      propertyListWrapper.classList.add('d-none');
      propertyListInvestment?.classList.add('d-xl-none');

      propertyListContentWrapper.insertAdjacentHTML(
        'beforeend',
        properties_ajax.loading_state
      );
    }

    try {
      // Fetch data
      const response = await fetch(properties_ajax.ajax_url, {
        method: 'POST',
        body: fetchParams,
      });

      const responseJson = await response.json();

      //converting response string to node elements
      const parser = new DOMParser();
      const htmlData = responseJson.data.html_data;
      const htmlInvestmentSection = responseJson.data.html_investment_section;
      const htmlSuggestedProperties = responseJson.data.html_suggested_properties;
      const htmlStatus = responseJson.data.html_status;
      const newOffset = responseJson.data.new_offset;
      const hasMore = responseJson.data.has_more;
      const newMapPoints = responseJson.data.new_map_points;

      // Clear data container if we filter data
      if (triggeredBySortFilter || !responseJson.success) {
        propertyList.innerHTML = '';
      }

      if (responseJson.success) {
        const articles = parser.parseFromString(htmlData, 'text/html').body.querySelectorAll('article');

        //appending nodes
        for (const article of articles) {
          propertyList.appendChild(article);
        }
      } else {
        const noContentDivTag = parser.parseFromString(htmlData, 'text/html').body.querySelector('div');

        propertyList.insertBefore(noContentDivTag, propertyList.firstChild);
      }

      updateInvestmentSectionContent(htmlInvestmentSection);
      updateSuggestedPropertiesContent(htmlSuggestedProperties);

      // Status bar update
      const statusPTagContent = parser.parseFromString(htmlStatus, 'text/html').body.querySelector('p');

      propertyListStatus.querySelector('p')?.remove();
      propertyListStatus.insertBefore(statusPTagContent, propertyListStatus.firstChild);

      // Show/hide sort buttons based on whether there are results
      const newTotal = parseInt(
        propertyListStatus.querySelector('[data-status-total-properties]')?.dataset?.statusTotalProperties || '0',
        10
      );
      const sortBtnsWrapper = propertyListStatus.querySelector('.property-sort-btns-wrapper');
      if (sortBtnsWrapper) {
        if (newTotal > 0) {
          // d-none stays — it hides on mobile; d-xl-flex overrides it on XL+
          sortBtnsWrapper.classList.add('d-xl-flex');
        } else {
          sortBtnsWrapper.classList.remove('d-xl-flex');
          sortBtnsWrapper.classList.add('d-none');
        }
      }

      // Update offset
      propertyList.dataset.offset = newOffset;

      // Show load more button
      if (!hasMore) {
        if (propertyLoadMoreBtn) propertyLoadMoreBtn.classList.add('d-none');
      } else {
        if (propertyLoadMoreBtn) propertyLoadMoreBtn.classList.remove('d-none');
      }

      if (listType === "property") {
        googleMapData.points = newMapPoints;
        initGoogleMap('google-map');
      }

      // Remove loading state
      const loadingState = propertyListContentWrapper.querySelector('.loading-state-wrapper');
      if (loadingState) {
        propertyListWrapper.classList.remove('d-none');
        propertyListInvestment?.classList.remove('d-xl-none');
        loadingState.remove();
      }

      // Update URL
      const currentURL = new URL(window.location.href);
      fetchParams.delete('security');
      fetchParams.delete('action');
      fetchParams.delete('list_type');
      fetchParams.delete('offset');
      fetchParams.delete('limit');
      fetchParams.delete('totalPropertiesStatus');
      fetchParams.delete('currentPropertiesStatus');
      currentURL.search = fetchParams;

      window.history.pushState({}, '', currentURL);

      syncFilters(fetchParams);

      const hasRentHoliday = !!responseJson.data.has_rent_holiday;
      updateRentHolidayVisibility(hasRentHoliday);

      if (!hasRentHoliday && fetchParams.has('rent-holiday')) {
        fetchParams.delete('rent-holiday');
        await asyncFetchPropertiesData(fetchParams, true);
      }
    } catch (error) {
      console.error('Something went wrong ;-/ \n', error);
    }
  }

  function updateInvestmentSectionContent(htmlInvestmentSection) {
    const parser = new DOMParser();

    if (listType === 'property' && htmlInvestmentSection) {
      const propertyListInvestmentH2 = propertyListInvestment.querySelector('h2');
      const propertyListInvestmentContent = propertyListInvestment.querySelector('.investment-info-content');

      const propertyListModalInvestmentH2 = propertyListModalInvestment.querySelector('h2');
      const propertyListModalInvestmentContent = propertyListModalInvestment.querySelector('.investment-info-content');

      // New sections content
      const investmentSectionH2InnerHTML = parser.parseFromString(htmlInvestmentSection, 'text/html').body.querySelector('section h2')?.innerHTML;
      const investmentSectionContent = parser.parseFromString(htmlInvestmentSection, 'text/html').body.querySelector('section .investment-info-content');

      const investmentSectionContentClassList = investmentSectionContent?.classList;
      const investmentSectionContentInnerHTML = investmentSectionContent?.innerHTML;

      if (investmentSectionH2InnerHTML) {
        propertyListInvestmentH2.innerHTML = investmentSectionH2InnerHTML;
        propertyListModalInvestmentH2.innerHTML = investmentSectionH2InnerHTML;
      }
      if (investmentSectionContent) {
        propertyListInvestmentContent.classList = investmentSectionContentClassList;
        propertyListInvestmentContent.innerHTML = investmentSectionContentInnerHTML;
        propertyListModalInvestmentContent.classList = investmentSectionContentClassList;
        propertyListModalInvestmentContent.innerHTML = investmentSectionContentInnerHTML;
      }
    }
  }

  // No-results suggested load more (delegated — button may be injected by AJAX)
  propertyListContentWrapper?.addEventListener('click', async (e) => {
    const btn = e.target.closest(`.${listType}-list__no-results-load-more-btn`);
    if (!btn) return;

    const btnSpinner = btn.querySelector('.spinner-border');
    btnSpinner?.classList.remove('d-none');
    btn.disabled = true;

    const offset = parseInt(btn.dataset.offset || '10', 10);
    const limit = parseInt(btn.dataset.limit || '20', 10);
    const excludeInvestment = btn.dataset.excludeInvestment || '0';
    const lat = btn.dataset.lat || '';
    const lng = btn.dataset.lng || '';

    const searchQueryParams = new URLSearchParams(window.location.search);
    const fetchParams = new URLSearchParams();

    // Pass active filter params so get_suggested_properties picks them up from $_POST
    ['rooms', 'area_from', 'area_to', 'max_price', 'balcony', 'garden', 'kitchen'].forEach(key => {
      if (searchQueryParams.has(key)) fetchParams.set(key, searchQueryParams.get(key));
    });

    if (searchQueryParams.has('city')) fetchParams.set('city', searchQueryParams.get('city'));

    fetchParams.append('action', 'no_results_suggested_ajax');
    fetchParams.append('security', properties_ajax.nonce);
    fetchParams.append('offset', offset);
    fetchParams.append('limit', limit);
    fetchParams.append('exclude_investment', excludeInvestment);
    if (lat) fetchParams.append('lat', lat);
    if (lng) fetchParams.append('lng', lng);

    try {
      const response = await fetch(properties_ajax.ajax_url, {
        method: 'POST',
        body: fetchParams,
      });
      const json = await response.json();

      if (json.success && json.data.html_data) {
        const container = propertyListContentWrapper.querySelector(`.${listType}-list__no-results-suggested-list`);
        if (container) {
          const parser = new DOMParser();
          const articles = parser.parseFromString(json.data.html_data, 'text/html').body.querySelectorAll('article');
          for (const article of articles) {
            container.appendChild(article);
          }
        }
      }

      btn.classList.add('d-none');
    } catch (error) {
      console.error('[No-results Load More] Error fetching data:', error);
    } finally {
      btnSpinner?.classList.add('d-none');
      btn.disabled = false;
    }
  });

  function updateSuggestedPropertiesContent(html) {
    if (listType !== 'property') return;
    const container = document.querySelector(`.${listType}-list__suggested-properties-list`);
    if (!container) return;
    const parser = new DOMParser();
    const newNode = parser.parseFromString(html || '', 'text/html').body.querySelector(`.${listType}-list__suggested-properties-list`);
    if (newNode) {
      container.replaceWith(newNode);
    } else {
      container.innerHTML = '';
    }
  }

  function updateRentHolidayVisibility(hasRentHoliday) {
    document.querySelectorAll('.special-offers').forEach(section => {
      if (hasRentHoliday) {
        section.classList.remove('d-none');
      } else {
        section.classList.add('d-none');
        const cb = section.querySelector('input[name="rent-holiday"]');
        if (cb) cb.checked = false;
      }
    });
  }

  function syncFilters(queryParams) {
    const filterFormInputList = document.querySelectorAll('[id^="property-filters-"]');
    filterFormInputList?.forEach(formInput => {
      if (formInput.type === "checkbox") {
        formInput.checked = formInput.value === queryParams.get(formInput.name);
      } else {
        formInput.value = queryParams.has(formInput.name) ? queryParams.get(formInput.name) : '';
      }
    });

    const sortFormInputList = document.querySelectorAll('[id^="property-sort-"]');
    sortFormInputList?.forEach(sortInput => {
      const inputSortOrder = sortInput.dataset.sortOrder;
      const inputSortField = sortInput.dataset.sortField;

      if (sortInput.type === "checkbox") {
        sortInput.checked = queryParams.get('order_by') === inputSortField && queryParams.get('order') === inputSortOrder;
      } else {
        sortInput.dataset.sortOrder = inputSortField === queryParams.get('order_by') ? queryParams.get('order') : inputSortOrder;

        sortInput.classList.toggle('active', queryParams.get('order_by') === inputSortField && queryParams.get('order') === sortInput.dataset.sortOrder);
      }
    });
  }

  // Radio behavior on checkboxes
  const roomsCheckboxes = document.querySelectorAll(
    '.radio-btns-group input[name="rooms"]'
  );
  roomsCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        roomsCheckboxes.forEach((cb) => {
          if (cb !== checkbox) cb.checked = false;
        });
      }
    });
  });

  const orderCheckboxes = document.querySelectorAll('.radio-btns-group input[name="order"]');
  orderCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        orderCheckboxes.forEach((cb) => {
          if (cb !== checkbox) cb.checked = false;
        });
      }
    });
  });
});
